<template>
  <div id="home">
    <div v-if="isGridView">
      <Header :isGridView="true" :isHomePage="true" @toggle-grid-view="handleToggleGridView"/>
      <GridDisplay />
    </div>
    <div v-else>
      <Header :isGridView="false" :isHomePage="true" @toggle-grid-view="handleToggleGridView"/>
      <FavoriteRecipeCarroussel />
      <AllRecipesList />
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import FavoriteRecipeCarroussel from '../components/FavoriteRecipeCarroussel.vue'
import AllRecipesList from '../components/AllRecipesList.vue'
import GridDisplay from '../components/GridDisplay.vue'

export default {
  name: 'Home',
  components: {
    Header,
    FavoriteRecipeCarroussel,
    AllRecipesList,
    GridDisplay
  },
  data() {
    return {
      isGridView: true
    };
  },
  mounted() {
    if(this.$route.params.isGridView != undefined)
      this.isGridView = this.$route.params.isGridView;

    this.handleToggleGridView(this.isGridView);
  },
  methods: {
    handleToggleGridView(newValue) {
      this.isGridView = newValue;
    }
  }
}
</script>

